/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_CtaInputs */

const en_salary_negotiate_cta = /** @type {(inputs: Salary_Negotiate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Script`)
};

const de_salary_negotiate_cta = /** @type {(inputs: Salary_Negotiate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skript generieren`)
};

const fr_salary_negotiate_cta = /** @type {(inputs: Salary_Negotiate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer le script`)
};

const es_salary_negotiate_cta = /** @type {(inputs: Salary_Negotiate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar guión`)
};

const it_salary_negotiate_cta = /** @type {(inputs: Salary_Negotiate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera script`)
};

const nl_salary_negotiate_cta = /** @type {(inputs: Salary_Negotiate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script genereren`)
};

const pl_salary_negotiate_cta = /** @type {(inputs: Salary_Negotiate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuj skrypt`)
};

const fi_salary_negotiate_cta = /** @type {(inputs: Salary_Negotiate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo neuvotteluskripti`)
};

const da_salary_negotiate_cta = /** @type {(inputs: Salary_Negotiate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer script`)
};

const sv_salary_negotiate_cta = /** @type {(inputs: Salary_Negotiate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generera manus`)
};

/**
* | output |
* | --- |
* | "Generate Script" |
*
* @param {Salary_Negotiate_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_cta = /** @type {((inputs?: Salary_Negotiate_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_cta(inputs)
	if (locale === "fr") return fr_salary_negotiate_cta(inputs)
	if (locale === "es") return es_salary_negotiate_cta(inputs)
	if (locale === "it") return it_salary_negotiate_cta(inputs)
	if (locale === "nl") return nl_salary_negotiate_cta(inputs)
	if (locale === "pl") return pl_salary_negotiate_cta(inputs)
	if (locale === "fi") return fi_salary_negotiate_cta(inputs)
	if (locale === "da") return da_salary_negotiate_cta(inputs)
	if (locale === "sv") return sv_salary_negotiate_cta(inputs)
	return en_salary_negotiate_cta(inputs)
});